

































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { State, Action, Mutation, Getter } from 'vuex-class'
import { Route } from 'vue-router'
import Draggable from 'vuedraggable'
import { RootState } from '@/store/types'
import { VAULT_TREE_OPEN, SET_SORT_ORDER } from '@/store/entries/constants'
import Entry from '@/data/entry-model'
import { SortOrderUpdate } from '@/store/entries/actions'
import { ENTRY_LOAD } from '@/store/editor/constants'
import VaultList from './VaultList.vue'

interface DragEvent extends Event {
    newIndex: number
    oldIndex: number
}

@Component({ name: 'vault-list-item', components: { VaultList, Draggable } })
export default class VaultListItem extends Vue {
    /**
     * Whether the vault is expanded
     */
    expanded: boolean = false

    /**
     * The entry information to display
     */
    @Prop({ type: Object })
    entry!: Entry

    /**
     * Whether this is a child of another item (e.g. not root)
     */
    @Prop({ type: Boolean, default: false })
    isChild!: boolean

    /**
     * Whether the items are drag- and drop-able
     */
    @State((state: RootState) => state.ui.dragDropVaults)
    dragDropVaults!: boolean

    /**
     * Load an entry into the editor
     */
    @Action(ENTRY_LOAD)
    loadEntry!: (entryId: string) => void

    /**
     * Push the vault onto the vault tree stack, and open the vault as
     * the current directory
     */
    @Action(VAULT_TREE_OPEN)
    openVaultTree!: (id: string) => void

    /**
     * Update the sort order for an entry
     */
    @Action(SET_SORT_ORDER)
    setSortOrder!: ({ entry, newIndex }: SortOrderUpdate) => Promise<Entry>

    @Getter
    searching!: boolean

    @Getter
    searchTags!: string[]

    /**
     * Whether the entry is currently open in the editor
     */
    get active(): boolean {
        return this.$route.path.includes(this.entry.id!)
    }

    /**
     * Whether the entry is a vault
     */
    get isVault(): boolean {
        return this.entry.isVault()
    }

    /**
     * Icon to display before the entry title
     */
    get icon(): string {
        if (this.expanded && (this.entry.icon === 'folder' || this.entry.icon === 'icon:folder')) {
            return 'icon:folder-open'
        }
        return this.entry.icon || 'bolt'
    }

    get subtitle(): string {
        return this.entry.subtitle
    }

    get children(): Entry[] {
        return this.entry.children
    }

    get upToDate(): boolean {
        return !this.entry.pendingUpdate
    }

    get searchPath(): string[] {
        return this.entry.titlePath
    }

    get matchedTags(): string[] {
        return this.entry.tags
            .filter(tag => this.searchTags.some(search => tag.includes(search)))
            .slice(0, 3)
    }

    onClick(): void {
        if (this.isVault) {
            this.toggleChildren()
        } else {
            this.load()
        }
    }

    /**
     * Attempt to load the entry into the editor
     *
     * Not available if the list item is 'home'
     */
    load(): void {
        this.loadEntry(this.entry.id!)
    }

    /**
     * Open the vault
     */
    openTree(): void {
        this.openVaultTree(this.entry.id!)
    }

    /**
     * Toggle showing child entries (for vaults)
     */
    toggleChildren(): void {
        this.expanded = !this.expanded
    }

    /**
     * Update the sort order of the entry when dragging ends
     */
    dragEnd({ newIndex, oldIndex }: DragEvent): void {
        this.setSortOrder({ entry: this.children[oldIndex], newIndex })
    }
}
